module.exports = __webpack_public_path__ + "img/desktop-neck-8_18x592.4bbda3b2.png";